/* eslint-disable @typescript-eslint/default-param-last */
import { PRESETS_SET, PRESETS_UPDATE_PRESET } from './actions';
import dotProp from 'dot-prop-immutable';

const initialState = null;

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PRESETS_SET:
      return action.payload;

    case PRESETS_UPDATE_PRESET:
      return dotProp.set(state, action.payload.key, action.payload.value);

    default:
      return state;
  }
};

export default reducer;
